import React from 'react';
import PageShell from '../PageShell';
import Loadable from 'react-loadable'
import Loading from '../../Loading'

//cta={{
//  title: "Watch Video",
//  href: "https://www.google.com",
//  color: "primary"
//}}


const LoadableProductSection = Loadable({
  loader: () => import('./Sections/ProductSection'),
  loading: Loading,
})

const LoadableTeamSection = Loadable({
  loader: () => import('./Sections/TeamSection'),
  loading: Loading,
})

const LoadableContactSection = Loadable({
  loader: () => import('./Sections/ContactSection'),
  loading: Loading,
})

const LandingPage = () => {
    return (
        <PageShell
            title="Your Practice Starts With Us."
            blurb="Resilient Vitality is more than practice management. It is a complete set of tools
      to help you do more with your practice and care even more for your patients. You take care of others.
      We take care of you."
            img={require('assets/img/landing-bg.jpg')}
            components={[
                <LoadableProductSection key={0} />,
                <LoadableTeamSection key={1} />,
                <LoadableContactSection key={2} />
            ]}
        />
    )
};

export default LandingPage



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx